import React from 'react';
import { Button, Grid, Box, useTheme, useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';

// Third-party Imports
import classnames from 'classnames';

// Styles Imports
import styles from './styles.module.css';
import { Colors } from './style/theme';

const TopHeading = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detects mobile devices

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      mt={isMobile ? 10 : 30}
      mb={isMobile ? 6 : 10}
      className={styles.topHeading}
    >
      <Box textAlign="center" maxWidth={isMobile ? '100%' : 'md'}>
        {/* Hero Heading */}
        <Typography
          variant={isMobile ? 'h4' : 'h2'} // Dynamic typography size for mobile
          className={classnames(styles.heroText)}
          gutterBottom
          fontWeight="bold"
          fontSize={isMobile ? '2rem' : '3rem'} // Adjust font size for smaller devices
          lineHeight="1.2"
        >
          InnoWave API Hub – Seamless <br />
          &amp; Affordable API Solutions
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
          fontSize={isMobile ? '1rem' : '1.2rem'}
          mt={3}
        >
          InnoWave API Hub by Tylect Technologies Pvt Ltd provides a wide range of hosted prepaid APIs,
          ensuring flexibility, reliability, and easy integration. Whether you need geocoding,
          reverse geocoding, name matching, or mobile number verification, our APIs empower
          your applications with essential tools to operate efficiently. Our platform ensures
          seamless API management with a transparent per-hit pricing model — giving businesses
          reliable, pay-per-use access to essential APIs without the burden of large upfront costs.
        </Typography>

        {/* Call to Action Section */}
        <Box mt={4} display="flex" justifyContent="center">
          <Button
            size="large"
            href="/signup"
            variant="contained"
            color="primary"
            sx={{
              padding: isMobile ? '12px 24px' : '16px 32px', // Dynamic button padding
              fontSize: isMobile ? '1rem' : '1.25rem', // Dynamic button font size
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: Colors.primaryDark,
              },
            }}
          >
            Get Started
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default TopHeading;
